exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2w_H1FHIJiex8x{padding:0 12px;position:relative;text-align:center}._31zzj4_6fYmztz{box-sizing:border-box;border-bottom:1px solid rgba(9,30,66,.13);color:#6b778c;display:block;height:40px;line-height:40px;margin-bottom:8px;overflow:hidden;padding:0 32px;position:relative;text-overflow:ellipsis;white-space:nowrap}._31zzj4_6fYmztz:focus{outline:0}._2NmjWAYlLOxGAT{padding:10px 12px 10px 8px;position:absolute;margin:0;right:0;top:0;z-index:1}._2NmjWAYlLOxGAT:active,._2NmjWAYlLOxGAT:hover{background:transparent}._2NmjWAYlLOxGAT:active>span,._2NmjWAYlLOxGAT:hover>span{color:#505f79}._2447LkZW6R50VW{padding:10px 8px 10px 12px;position:absolute;left:0;margin:0;top:0;z-index:1}._2447LkZW6R50VW:active,._2447LkZW6R50VW:focus,._2447LkZW6R50VW:hover{background:transparent}._2447LkZW6R50VW:active>span,._2447LkZW6R50VW:focus>span,._2447LkZW6R50VW:hover>span{color:#505f79}", ""]);

// exports
exports.locals = {
	"header": "_2w_H1FHIJiex8x",
	"headerTitle": "_31zzj4_6fYmztz",
	"headerClose": "_2NmjWAYlLOxGAT",
	"headerBack": "_2447LkZW6R50VW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/popover/popover-header.less
// module id = KuRo
// module chunks = 24